import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const removePartnerCaller = async ({ partnerId, callerId }: { partnerId: number; callerId: string }) => {
  const response = await mutationExecute({
    variables: {
      partnerId,
      callerId,
    },
    mutation: graphql(`
      mutation RemovePartnerCaller($partnerId: Float!, $callerId: String!) {
        removePartnerCaller(partnerId: $partnerId, callerId: $callerId) {
          callerId
          partnerId
        }
      }
    `),
  });

  return !!response.data?.removePartnerCaller;
};
